import axios from "axios";
import { useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import Refuse_Access_Template from "../../Ressources/MailsTemplates/Refused_Access_Template";
import '../../Features/Forms/Components/AccessSentMailPopUp/AccessSentMailPopUp.css';
import BackButton from "../../Components/BackButton/BackButton";

const AdminValidationRefusedPage: React.FC = () => {
    
    
    const location = useLocation();

    useEffect(() => {

        window.scrollTo(0, 0);
        const params = new URLSearchParams(location.search);
        const TargetMail = params.get('UserMail');
        const AdminMail = params.get('AdminMail');


        const fetchData = async () => {
            // we set the html template for the mail
            let htmlTemplate = "";
            if (AdminMail) {
                htmlTemplate = await ReplaceDynamicValue(await Refuse_Access_Template, AdminMail);
            } else {
                console.error('AdminMail is null');
                return;
            }

            const brevoApiKey = process.env.REACT_APP_BREVO_API_KEY;

            if (!brevoApiKey) {
                alert('BREVO API key is missing');
                return;
            }

            // we need another axios instance to use Brevo API
            const BrevoAxiosOptions = {
                method: 'POST',
                url: 'https://api.brevo.com/v3/smtp/email',
                headers: {
                    accept: 'application/json',
                    'content-type': 'application/json',
                    'api-key': brevoApiKey
                },
                data: {
                    sender: { name: "Paluel-OnlyContact", email: "paluel@onlycontact.fr" },
                    to: [{ email: TargetMail, name: TargetMail }],
                    htmlContent: htmlTemplate,
                    subject: "Votre demande d'accès a Paluel-OnlyContact a été refusée.",
                    replyTo: { email: "paluel@onlycontact.fr", name: "Paluel-OnlyContact" }
                }
            };

            axios.request(BrevoAxiosOptions)
                .then()
                .catch(err => console.error(err));
        };

        fetchData();

    }, [location]);

    return (
        <>
            <BackButton returnToHome={true} />

            <div className="PopUpDiv">
                <p className="PopUpMessage">Vous venez de Refuser une demande d'accèes. Un mail a été envoyé au demandeur pour le notifier de cette décision. vous pouvez maintenant retourner sur la page d'accueil.</p>
            </div>
        </>
    );
}

export default AdminValidationRefusedPage;


async function ReplaceDynamicValue(htmlTemplate: string, mailToRespond: string): Promise<string> {
    const dynamicValues = {
        '{{Mail}}': mailToRespond,
    };

    let modifiedHtml = htmlTemplate;

    for (const [key, value] of Object.entries(dynamicValues)) {
        const regex = new RegExp(key, 'g');
        modifiedHtml = modifiedHtml.replace(regex, value);
    }

    return modifiedHtml;
}
